(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('dateFormatter', ['DateUtils',
    function (DateUtils) {
        return {
            restrict: 'A',
            require: '^?ngModel',
            link: function postLink(scope, element, attrs, ctrls) {
            	if(ctrls != null){
//            		ctrls.$formatters.push(function(data) {
//            			console.log("loque hay en fecha " + data);
//            			var tiempoEnMiliSegundos = Date.parse(data);
//            			console.log("tiempoEnMiliSegundos " + tiempoEnMiliSegundos);
//            			data = new Date(tiempoEnMiliSegundos);
//            			console.log("nuevo data de milisegundos " + tiempoEnMiliSegundos);
//            			return data;
////	                  	  	console.log("$formatters.push " + data);
////	        				var out = new Date(data);
//////	                  	  	var out = DateUtils.convertLocalDateToServer(data);
////	            			console.log("$formatters.out =" + out);
////	            			return out;
//        		    });
                  	
//                  	console.log("ngModel es  " + ctrls);
//                  	ctrls.$parsers.push(function(data) {
//	                  	  console.log("parsers.push " + data);
//	                  	  var out = DateUtils.convertLocalDateToServer(data);
//	                      console.log("$parsers.out = " + out);
//	            		  return out;
//        		    });
            	}
                
            	
            	
            }
        };
    }
])
})();

